import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import styles from './Tooltip.scss'

const Tooltip = ({ className, tip }) => {
  return (
    <div className={classnames(styles.base, styles.left, className)}>
      {tip}
    </div>
  )
}

Tooltip.propTypes = {
  className: PropTypes.string,
  tip: PropTypes.string.isRequired,
}

Tooltip.defaultProps = {
  className: null,
}

export default Tooltip



// WEBPACK FOOTER //
// ./src/components/Tooltip/Tooltip.js